const system = {
  menuManager: {
    menu: "Menu",
    button: "Button",
    menuName: "Menu name(CN)",
    menuNameEn: "Menu name(EN)",
    link: "Link",
    menuType: "Menu type",
    sort: "Sort",
    isShow: "Display or not",
    weight: "Menu weight",
    otherWeight: "Extend menu weight",
    create: "Add",
    update: "Update",
    delete: "Delete",
    topLevelMenu: "Top-level menu",
    parentMenu: "Parent menu",
    icon: "Icon",
    hide: "Hide",
    show: "Show",
    permission: "Permission ID",
    msg: {
      error1: "Please enter Chinese menu name",
      error2: "Please enter the sort number",
      error3: "Please enter English menu name",
      error4: "Please select menu weight"
    },
    weightList: {
      list1: "Developers",
      list2: "V2x",
      list3: "Channel",
      list4: "Company",
      list5: "Sub Company",
      list6: "Department"
    },
    rightLabelWidth: "135px",
    leftLabelWidth: "135px"
  },
  repair: {
    searchTitle: "Item name",
    searchTitle1: "Item group",
    searchName: {
      first: "Basic Repair",
      second: "Deep Repair"
    },
    itemName: "Item name",
    itemNameEn: "English name of the item",
    itemType: "Item group",
    readOnly: "Created by yourself",
    createdOn: "Creation time",
    tableWidth: {
      itemName: "100",
      itemNameEn: "100",
      itemType: "100",
      createdOn: "110",
      readOnly: "100"
    },
    create: "New Repair",
    update: "Editor Repair",
    msg: {
      error1: "Please enter the item name",
      error2: "Please enter the English name of the item",
      error3: "Please select item group",
      readOnly: "No",
      editable: "Yes",
      readOnlyTip: "You don't have permission to operate this item"
    }
  },
  maintenance: {
    searchTitle: "Item name",
    searchTitle1: "Item group",
    searchName: {
      first: "Basic Maintenance",
      second: "Deep Maintenance",
      third: "Cleaning And Maintenance",
      custom: "Custom"
    },
    itemName: "Item name",
    itemNameEn: "English name of the item",
    itemType: "Item group",
    createdOn: "Creation time",
    tableWidth: {
      itemName: "100",
      itemNameEn: "100",
      itemType: "100",
      createdOn: "110",
      readOnly: "100"
    },
    create: "New maintenance",
    update: "Edit maintenance",
    readOnly: "Created by yourself",
    msg: {
      error1: "Please enter the item name",
      error2: "Please enter the English name of the item",
      error3: "Please select item group",
      readOnly: "No",
      editable: "Yes",
      readOnlyTip: "You don't have permission to operate this item"
    }
  },
  user: {
    searchName: "Account / name",
    loginAccount: "Login name",
    userName: "Name",
    role: "Role",
    lockStatus: "Lock status",
    userRole: "User role",
    accountType: "Account type",
    accountStatus: "Account status",
    enable: "Enable ",
    ban: "Disable ",
    restPwdTips: "Please select the user needs to reset the password",
    openingTime: "Create Time",
    searchLabelWidth1: "100px",
    yes: "Yes",
    no: "No",
    labelWidth: "110px",
    msg1: "After reset， the password is 12345678",
    msg2: "Password reset succeeded",
    tips: "Please select the item that needs to be reset",
    passwordTips: "Please check the item requiring password reset",
    tableWidth: {
      loginAccount: "130",
      userName: "120",
      accountStatus: "140",
      phoneNumber: "140",
      openingTime: "140"
    },
    createAndUpdate: {
      create: "Add new user",
      update: "Edit user",
      msg: {
        error1: "Please enter the login account",
        error2: "Please enter user name",
        error3: "Please select a role"
      }
    },
    banTips: "Disable users"
  },
  defaultPwd: "Default password",
  logs: {
    login: {
      loginAccount: "Login name",
      userName: "User name",
      clientIP: "Client IP",
      resultsLogin: "Login result",
      accountType: "Account type",
      loginTime: "Login time",
      clientBrowser: "Client browser",
      searchWidth: {
        width1: "90px",
        width2: "80px",
        width3: "65px",
        width4: "80px"
      },
      success: "Success",
      fail: "Failure"
    },
    oper: {
      loginAccount: "Login name",
      userName: "User name",
      clientIP: "Client IP",
      roleName: "Role name",
      operatingFunctions: "Oper functions",
      operatingActions: "Operation Action",
      operationDescription: "Oper description",
      operatingTime: "Operation Time",
      browserInformation: "Browser information",
      operatingResults: "Operation results",
      searchWidth: {
        width1: "90px",
        width2: "80px",
        width3: "120px",
        width4: "90px"
      },
      tableWidth: {
        loginAccount: "130",
        userName: "140",
        roleName: "130",
        operatingFunctions: "180",
        operatingResults: "150",
        browserInformation: "180"
      }
    },
    lifecycle: {
      loginAccount: "Login name",
      userName: "User name",
      accountType: "Account type",
      logDescription: "Log description",
      logType: "Log type",
      operatingTime: "Operation time",
      operator: "Operator",
      operationDescription: "Operation description",
      searchWidth: {
        width1: "100px",
        width2: "80px",
        width3: "90px",
        width4: "100px"
      },
      tableWidth: {
        loginAccount: "130",
        userName: "110",
        operator: "100",
        accountType: "130",
        roleName: "100",
        logType: "150",
        operatingTime: "240"
      }
    }
  },
  role: {
    name: "Role management",
    searchLabelWidth: "120px",
    remark: "Remark",
    isSys: "System role",
    dataScope: "Data permission",
    datascope0: "Not set",
    datascope1: "All",
    tips: "Please select the item to be set",
    tableWidth: {
      name: "130px",
      isSys: "100px",
      dataScope: "150px"
    },
    create: "New role",
    update: "Edit role",
    basicInfo: "Basic info",
    menu: "Permission Function Menu",
    error: "Please enter the role name"
  },
  channel: {
    create: "Add New Channel",
    update: "Edit Channel Manager",
    name: "Channel Name",
    channelLabelWidth: "102px",
    info: "Channel Information",
    define: "save",
    edit: "Edit Channel",
    tips: "Please select Channel",
    confirm: "OK",
    delete: "Delete Channel",
    deleteItemTips: "Do you want to delete selected channel?",
    resetPassword: "Reset Channel Password",
    msg: "Please confirm to reset password. The default password is 12345678.",
    obdTips: "OBD Authorization",
    valid: {
      name: "Please enter the channel name"
    }
  },
  company: {
    name: "Company name",
    searchLabelWidth: "100px",
    remark: "Remark",
    tableWidth: {
      name: "130px",
      isSys: "80px",
      dataScope: "150px"
    },
    create: "New company",
    update: "Edit company",
    info: "Company information",
    admin: "Administrator Information",
    adminAccount: "Login Name",
    adminRealName: "Name",
    phoneNumber: "Mobile No.",
    dialogLabelWidth: "120px",
    valid: {
      name: "Please enter the company name",
      account: "Please enter the company administrator account",
      realName: "Please enter the company administrator name",
      mobile: "Incorrect mobile phone number"
    },
    obdCount: "Authorized Device",
    addObd: "Add OBD authorization",
    removeObd: "Remove OBD authorization"
  },
  subCompany: {
    name: "Sub company name",
    subCompanyLabelWidth: "120px",
    create: "Create sub company",
    update: "Edit sub company",
    info: "Sub company information",
    valid: {
      name: "Please enter the sub company name"
    }
  },
  department: {
    name: "Department name",
    create: "New department manager",
    update: "Edit Department Manager",
    departmentLabelWidth: "110px",
    info: "Department information",
    valid: {
      name: "Please enter the department name"
    }
  },
  brand: {
    brand: {
      brandName: "Brand name",
      brandIcon: "Brand icon",
      brandCode: "Brand code",
      addBrand: "Add brand",
      editBrand: "Edit brand",
      selectIcon: "Select Brand Icon",
      carSeries: "Car series",
      errorIcon: "Please select a brand icon",
      errorName: "Please enter brand name",
      errorCode: "Please enter brand code",
    },
    series: {
      seriesName: "Series name",
      seriesCode: "Series code",
      addSeries: "Add series",
      editSeries: "Edit series",
      carModel: "Car model",
      goBackBrand: "Go back to car brand",
      errorName: "Please enter series name",
      errorCode: "Please enter series code",
    },
    model: {
      modelName: "Model name",
      modelCode: "Model code",
      addModel: "Add model",
      editModel: "Edit model",
      modelMaintenanceKm: "Model maintenance kilometer",
      modelMaintenanceTime: "Model maintenance time",
      modelDisplacement: "Model displacement",
      displacementUnit: "Displacement unit",
      modelCylinder: "Model cylinder",
      modelYear: "Model year",
      goBackSeries: "Go back to car series",
      errorName: "Please enter model name",
      errorCode: "Please enter model code",
    },
    brandLabelWidth: "80px",
    remark: "Remark",
  },
  pdpa:{
    labelWidth:'100px',
    appName:'App name',
    version: 'Version',
    createTime: 'Creation time',
    thailandurl: 'Thai url',
    englishurl: 'English url',
    fabu:'Release',
    yifabu:'The published',
    tableWidth:{
      appName:'100px',
      version: '100px',
      createTime: '140px',
      thailandurl: '250px',
      englishurl: '250px',
    },
    labelWidth2:'150px',
    v2x:'V2X-A2',
    playconnect:'PlayConnect',
    typeSelect:'Effective date',
    thailand: 'Thailand',
    english: 'English',
    appTypemsg:'Please select the App type',
    effectiveDatemsg:'Please select an effective time',
    // pdpatyzt:'PDPA consent status',
    // pdpaversion:'PDPA version',
    // pdpatime:'PDPA consent time',
    // pdpaappname:'App name',
    playCtyzt:'PlayConnect_PDPA consent status',
    playCversion:'PlayConnect_PDPA version',
    playCtime:'PlayConnect_PDPA consent time',
    v2xtyzt:'V2X-A2_PDPA consent status',
    v2xversion:'V2X-A2_PDPA version',
    v2xtime:'V2X-A2_PDPA consent time',
    tipsfabu:"Are you sure to publish?",
    ty:'Agree',
    bty:"Don't agree with"
  }
}
export default system